import React from "react";
import styled from "styled-components";

import OrderDetailMobile from "./OrderDetailMobile";
import OrderDetailWeb from "./OrderDetailWeb";

// Responsive visibility styled components
const WebOnlyLayout = styled.div`
  display: none;
  
  @media (min-width: 1024px) {
    display: block;
  }
`;

const MobileOnlyLayout = styled.div`
  display: block;
  
  @media (min-width: 1024px) {
    display: none;
  }
`;

const OrderDetail: React.FC = () => {

  return (
    <>
      <WebOnlyLayout>
        <OrderDetailWeb />
      </WebOnlyLayout>

      <MobileOnlyLayout>
        <OrderDetailMobile />
      </MobileOnlyLayout>
    </>
  );
};

export default OrderDetail;
